import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { api, getErrorMessage } from '@/shared/api/client';
import { useAuthStore } from '@/store/auth.store';

export const changePasswordApi = {
  change: async (currentPassword: string, newPassword: string) =>
    (await api.post<void>('/api/v1/auth/change-password', { currentPassword, newPassword })).data,
};

export const useChangePassword = () => {
  return useMutation({
    mutationFn: ({ currentPassword, newPassword }: { currentPassword: string; newPassword: string }) =>
      changePasswordApi.change(currentPassword, newPassword),
    onSuccess: () => {
      const user = useAuthStore.getState().user;
      if (user) {
        useAuthStore.getState().setSession({
          accessToken: useAuthStore.getState().accessToken!,
          accessExpiresAtUtc: useAuthStore.getState().accessExpiresAtUtc!,
          user: { ...user, mustChangePassword: false },
        });
      }
      toast.success('Password changed. Other sessions were signed out.');
    },
    onError: (e) => toast.error(getErrorMessage(e)),
  });
};
